// Parameters coming from npm start or build;

console.log("process.env.REACT_APP_API_ENDPOINT")
console.log(process.env.REACT_APP_API_ENDPOINT)

export const SPARQL_ENDPOINT = encodeURI(process.env.REACT_APP_API_ENDPOINT);
export const LANG = process.env.REACT_APP_LANG ? process.env.REACT_APP_LANG : 'en';

// Tuscany universities
export const TUSCANY_UNIVERSITIES = [
    { id: 3206, label: 'Istituto Italiano di Scienze Umane'},
    { id: 95, label: 'Scuola IMT - Istituzioni, Mercati, Tecnologie - Alti Studi - Lucca'},
    { id: 50, label: 'Scuola Normale Superiore di Pisa'},
    { id: 51, label: "Scuola Superiore di Studi Universitari e Perfezionamento Sant Anna"},
    { id: 20, label: 'Università degli Studi di Firenze'},
    { id: 69, label: 'Università degli Studi di Siena'},
    { id: 49, label: 'Università di Pisa'},
    { id: 70, label: 'Università per Stranieri di Siena'}
]
// Tuscany universities for isotypes
export const ISOTYPES_TUSCANY_UNIVERSITIES = [
    { id: 95, label: 'Scuola IMT - Istituzioni, Mercati, Tecnologie - Alti Studi - Lucca'},
    { id: 50, label: 'Scuola Normale Superiore di Pisa'},
    { id: 51, label: "Scuola Superiore di Studi Universitari e Perfezionamento Sant'Anna"},
    { id: 20, label: 'Università degli Studi di Firenze'},
    { id: 69, label: 'Università degli Studi di Siena'},
    { id: 49, label: 'Università di Pisa'},
    { id: 70, label: 'Università per Stranieri di Siena'}
]

// common config for the vega vizs
export const VEGA_CONFIG = {
    title: {
        fontFamily: 'Zilla Slab'
    }
};

export const LANG_SPECIFICS = {
    'en': {
        HOME_LINK: 'https://www.toscanaopenresearch.it/en/the-project/',
        BUMPCHART_COLOR_DOMAIN: [
            "Aerospace - Area PNR",
            "Agrifood - Area PNR",
            "Blue Growth - Area PNR",
            "Green Chemistry - Area PNR",
            "Cultural Heritage - Area PNR",
            "Design, Creativity and Made in Italy - Area PNR",
            "Energy - Area PNR",
            "Smart Factory - Area PNR",
            "Life Sciences - Panel ERC",
            "Sustainable Mobility - Area PNR",
            "Physical sciences and Engineering - Panel ERC",
            "Health - Area PNR",
            "Smart, Secure and Inclusive Communities - Area PNR",
            "Social and Human Sciences - Panel ERC",
            "Technologies for Living Environments - Area PNR"
        ],
        BEESWARM_LEGEND_FORMAT: "'€ ' + format(datum.value, '.2s')",
        BEESWARM_TOOLTIP_FORMAT: "'€' + format(datum[\"founderCapital\"], '.2s')"
    },
    'it': {
        HOME_LINK: 'https://www.toscanaopenresearch.it/il-progetto/',
        BUMPCHART_COLOR_DOMAIN: [
            "Aerospazio - Area PNR",
            "Agrifood - Area PNR",
            "Blue Growth - Area PNR",
            "Chimica Verde - Area PNR",
            "Cultural Heritage - Area PNR",
            "Design, creatività e Made in Italy - Area PNR",
            "Energia - Area PNR",
            "Fabbrica Intelligente - Area PNR",
            "Scienze della Vita - Panel ERC",
            "Mobilità Sostenibile - Area PNR",
            "Scienze fisiche e Ingegneria - Panel ERC",
            "Salute - Area PNR",
            "Smart, Secure and Inclusive Communities - Area PNR",
            "Scienze Sociali e Umanistiche - Panel ERC",
            "Tecnologie per gli Ambienti di Vita - Area PNR"
        ],
        BEESWARM_LEGEND_FORMAT: "format(datum.value, '.2s') + ' €'",
        BEESWARM_TOOLTIP_FORMAT: "format(datum[\"founderCapital\"], '.2s') + '€'"
    }
}